import '@fontsource/roboto';
import './lib/firebase';
import { createTheme, StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import { Route, Switch } from "react-router-dom";
import { Redirect } from 'react-router';
import OnBoarding from './pages/Onboarding';
import { useEffect, useState } from 'react';
import { fireAuth, firebase } from './lib/firebase';
import { themeOptions } from 'styles/themeOptions';
import MessagePage from 'components/MessagePage';
import ProtectedRoute from 'components/ProtectedRoute';
import Piacere from 'pages/Piacere';
import SceltaIniziale from 'pages/SceltaIniziale';
import ScopriAreaX from 'pages/ScopriAreaX';
import CosaAreaX from 'pages/CosaAreaX';
import ScopriIc from 'pages/ScopriIc';
import DemoCenter from 'pages/DemoCenter';
import GiocaPepper from 'pages/GiocaPepper';
import PepperInteract from 'pages/PepperInteract';
import Contatti from 'pages/Contatti';
import PepperOccupato from 'pages/PepperOccupato';
import Listeners from 'components/Listeners';
import Fine from 'pages/Fine';
import WallLoghi from 'pages/WallLoghi';
import { tokenAtom } from 'lib/globalState';
import { useSetRecoilState } from 'recoil';
import Scansiona from 'pages/Scansiona';
import PepperOffline from "./pages/PepperOffline";

const theme = createTheme(themeOptions);


function MyApp(){
	const [signedIn, setSignedIn] = useState(false);
	const [message, setMessage] = useState("Caricamento...");
	const setToken = useSetRecoilState(tokenAtom);

	useEffect(() => {
		fireAuth.setPersistence(firebase.auth.Auth.Persistence.NONE) // on production change to none?
		.then(() => fireAuth.signInAnonymously())
		.then(() => {
			setSignedIn(true);
		})
		.catch((error: any) => {
			const errorCode = error.code;
			const errorMessage = error.message;
			console.log(errorCode, errorMessage);
		});

		firebase.auth().onAuthStateChanged((user) => {
			if (!user){
				console.log("invalidating local token");
				setToken(undefined);
			}
		});

	}, []);


	return (
		<StyledEngineProvider injectFirst>
			<ThemeProvider theme={theme}>
				<Listeners/>
				{
					signedIn ?
						<Switch>
							<ProtectedRoute path="/piacere" component={Piacere}/>
							<ProtectedRoute path="/scelta_iniziale" component={SceltaIniziale}/>
							<ProtectedRoute path="/scopri_areax" component={ScopriAreaX}/>
							<ProtectedRoute path="/areax" component={CosaAreaX}/>
							<ProtectedRoute path="/scopri_ic" component={ScopriIc}/>
							<ProtectedRoute path="/democenter" component={DemoCenter}/>
							<ProtectedRoute path="/pepper_occupato" component={PepperOccupato}/>
							<ProtectedRoute path="/contatti_areax" company="areax" component={Contatti}/>
							<ProtectedRoute path="/contatti_ic" company="ic" component={Contatti}/>
							<ProtectedRoute path="/gioca_pepper" component={GiocaPepper}/>
							<ProtectedRoute path="/pepper_selfie" component={PepperInteract} mode="selfie"/>
							<ProtectedRoute path="/pepper_swag" component={PepperInteract} mode="swag"/>
							<ProtectedRoute path="/pepper_balla" component={PepperInteract} mode="balla"/>
							<ProtectedRoute path="/pepper_esulta" component={PepperInteract} mode="esulta"/>
							<Route path="/pepper_offline">
								<PepperOffline/>
							</Route>
							<Route path="/scansiona">
								<Scansiona/>
							</Route>
							<Route path="/wall_loghi_piacere">
								<WallLoghi next="/piacere"/>
							</Route>
							<Route path="/wall_loghi_fine">
								<WallLoghi/>
							</Route>
							<Route path="/instanceid/:instanceId">
								<OnBoarding/>
							</Route>
							<Route exact path="/404">
								<MessagePage message={"Pagina non trovata, scansiona il qr code"}/>
							</Route>
							<Route path="/fine">
								<Fine/>
							</Route>
							<Route exact path="/">
								<OnBoarding/>
							</Route>

							<Route path="*">
								<Redirect to="/404"/>
							</Route>
						</Switch>
						:
						<MessagePage message={message}/>
				}
			</ThemeProvider>
		</StyledEngineProvider>
	);
}


export default MyApp;